    // for menu to disappear
    const body= document.body;
    const bsc_menuHeight = document.getElementsByClassName("section-header")[0].offsetHeight;

    let bsc_lastScroll = 0;

    window.addEventListener('scroll',()=>{
        const bsc_currentScroll = window.pageYOffset

        if (bsc_currentScroll <= bsc_menuHeight){
            body.classList.remove("bsc-scroll-up")
        }
        else if(bsc_currentScroll > bsc_lastScroll && !body.classList.contains("bsc-scroll-down" && bsc_currentScroll > bsc_menuHeight )){
            body.classList.remove("bsc-scroll-up")
            body.classList.add("bsc-scroll-down")
        }
        else if(bsc_currentScroll < bsc_lastScroll && body.classList.contains("bsc-scroll-down")){
            body.classList.remove("bsc-scroll-down")
            body.classList.add("bsc-scroll-up")
        }

        bsc_lastScroll = bsc_currentScroll;
    });